export default __webpack_public_path__ + "static/media/ana-julia-escobar.fe397688.jpeg";